import React, { useEffect, useState} from 'react'
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import {makeStyles} from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import CustomerDetails from './CustomerDetails'
import TireDetails from './TireDetails'
import ProcessDetails from './ProcessDetails'
import OrderStatus from './OrderStatus'
import ERPStatus from './ERPStatus';
import Input from '@material-ui/core/Input';
import SearchIcon from '@material-ui/icons/Search';
import InfoIcon from '@material-ui/icons/Info';
import {convertISODateTimeToBRLocale} from "../../common/Util";
import {getServiceOrderDetail} from "../../actions/orderActions";
import {useDispatch} from "react-redux";
import OrdemServicoAdd from "../OrdemServicos/OrdemServicoAdd";


const useStyles = makeStyles(theme => ({
  dashboardCardSection: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1) * 8
  },
  newServiceOrderTooltip: {
    position: 'fixed',
    top: '90vh',
    right: '2vh',
  },
  leftMargin: {
    marginLeft: theme.spacing(1),
      textAlign: 'center'

  },
  button: {
    margin: theme.spacing(1)
  },
  infoIcon: {
    verticalAlign: "middle"
  },
  progress: {
    margin: theme.spacing(1) * 2,
  },
  gridItem: {
    margin: '3px',
  },
  formControl: {
    margin: '3px',
  },
    textCenter:{
       textAlign: 'center',
      marginBottom: '15px'
    }

}));

const imagens= [
  {esq: 'E1.jpg', centro: 'M1.jpg', dir: 'D1.jpg'},
  {esq: 'E2.jpg', centro: 'M2.jpg', dir: 'D2.jpg'},
  {esq: 'E3.jpg', centro: 'M3.jpg', dir: 'D3.jpg'},
  {esq: 'E4.jpg', centro: 'M4.jpg', dir: 'D4.jpg'},
  {esq: 'E5.jpg', centro: 'M5.jpg', dir: 'D5.jpg'},
  {esq: 'E6.jpg', centro: 'M6.jpg', dir: 'D6.jpg'},
  {esq: 'E7.jpg', centro: 'M7.jpg', dir: 'D7.jpg'},
]

const OrderDetailsView = (props) => {
   const classes = useStyles();
   const [inputServiceOrderId, setInputServiceOrderId] = useState('');  // props.serviceOrderId || ''
  const [addDialogOS, setAddDialogOS] = useState(false);
   const dispatch = useDispatch();


  useEffect( () => {
    if (props.navUrl && props.navUrl.params && props.navUrl.params.ordemServico) {
        const x = props.navUrl.params.ordemServico;
        console.log("useEffect url match",x);
        setInputServiceOrderId(x);
        dispatch(getServiceOrderDetail(x));
    }
  }, [ props.navUrl ]);

const closeAddDialog = () => {
  setAddDialogOS(false);
}
  const handleChange = (event) => {
    setInputServiceOrderId(event.target.value);
  };


  const renderSearchComponent = () => {
    return (
        <div className={classes.textCenter}>
          <Typography variant="subtitle1">

            <Input
              type="search"
              name="inputServiceOrderId"
              className={classes.leftMargin}
              value={inputServiceOrderId}
              onChange={handleChange}
              placeholder="Ordem de Serviço ID"
            />
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={() => dispatch(getServiceOrderDetail(inputServiceOrderId))}
              >
              Pesquisar
              <SearchIcon className={classes.leftMargin}  />
            </Button>
            <Button
                variant="contained"
                color="secondary"
                className={classes.button}
                onClick={ () => { setAddDialogOS(true); } }
            >
              Adicionar|Editar O.S.
              <AddIcon className={classes.leftMargin}  />
            </Button>

          </Typography>
        </div>
    )
  }

  const renderContent = () => {
    // const classes = useStyles();
    const {
      ordemServicoId,
      description,
      tireDetails,
      processDetails,
      orderStatus,
      customerDetails
       } = props;


    return (
      <React.Fragment>
        <div xs={12}>
          <Typography >{description}</Typography>
        </div>
        <div className={classes.dashboardCardSection}>
          <Grid container direction="column" >
            <Grid container item direction="row" alignItems="stretch">
              <Grid item xs={12} sm={12} md={3}>
                <TireDetails
                  model={tireDetails.modelo}
                  brand={tireDetails.fabricante}
                  size={tireDetails.medida}
                  marcaFogo={tireDetails.marcaFogo}
                  dot={tireDetails.dot}
                  vida={tireDetails.vida}
                  banda={tireDetails.banda}
                  itemBandaAplicada={tireDetails.itemBandaAplicada}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <OrderStatus
                    os={ordemServicoId}
                    ordemServicoSequencia={orderStatus.ordemServicoSequencia}
                    processo={orderStatus.processo}
                    arrivedAt={convertISODateTimeToBRLocale(orderStatus.DTChegada)}
                    startProductionAt={convertISODateTimeToBRLocale(orderStatus.DTInicioProducao)}
                    completedAt={convertISODateTimeToBRLocale(orderStatus.DTFimProducao)}
                    despachedAt={convertISODateTimeToBRLocale(orderStatus.DTSaida)}
                    updatedAt={convertISODateTimeToBRLocale(orderStatus.modifiedOn)}
                    questions={convertISODateTimeToBRLocale(orderStatus.questions)}
                    etapa={orderStatus.etapa}
                    situacao={orderStatus.situacao}
                    teveRetrabalho={orderStatus.teveRetrabalho}
                    osId={orderStatus.id}
                    isCustomStyle
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <CustomerDetails
                  nome={customerDetails.nome}
                  legadoId={customerDetails.legadoId}
                  cpfcnpj={customerDetails.cpfcnpj}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <ERPStatus
                    ostatus={orderStatus}
                />
              </Grid>

            </Grid>

            <Grid container item>
              <Grid item xs={12}>
                <ProcessDetails
                  name={processDetails.name}
                  description={processDetails.description}
                  steps={processDetails.steps}
                />
              </Grid>
            </Grid>

          </Grid>

        </div>
      </React.Fragment>
    )
  }

  const renderServiceOrderDetails = () => {
    return (
      <React.Fragment>
        {renderSearchComponent()}

        { addDialogOS && <OrdemServicoAdd isOpen={addDialogOS} closeDialog={closeAddDialog} /> }
        {!addDialogOS && renderContent()}
      </React.Fragment>
    )
  }

  const renderNoDataScreen = () => {
    return (
      <React.Fragment>
        {renderSearchComponent()}
        { addDialogOS && <OrdemServicoAdd isOpen={addDialogOS} closeDialog={closeAddDialog} /> }
        <Typography align="center">
          <InfoIcon className={classes.infoIcon} /> Por favor informe a Ordem de Serviço para visualizar detalhes.
        </Typography>
      </React.Fragment>
    )
  }

  const renderLoadingScreen = () => {
    return (
      <React.Fragment>

        {this.renderSearchComponent()}
        <div align="center">
          <CircularProgress className={classes.progress} />
        </div>
      </React.Fragment>
    )
  }



    const { isLoading, ordemServicoId } = props;
    return (
        <React.Fragment>
        {isLoading ?
             renderLoadingScreen() : (ordemServicoId ? renderServiceOrderDetails() : renderNoDataScreen() ) }
        </React.Fragment>
    );

}

export default (OrderDetailsView);
